import React, { useState } from "react";
import { Link } from "react-router-dom";
import ConsultancyNavbar from "../ConsultancyNavbar";
import ConsultancyFooter from "../ConsultancyFooter";

const BlogPage = () => {
  const [searchTerm, setSearchTerm] = useState("");

  const articles = [
    { id: 1, title: "UK Post-Study Work Visa 2026: Complete Policy Update & Rules", category: "Visa Updates", date: "August 8, 2026", author: "EdOps Visa Desk", img: "https://images.unsplash.com/photo-1513635269975-59663e0ac1ad?auto=format&fit=crop&w=600&q=80", snippet: "Everything international students need to know about the Graduate Route 2-year work permit extension, salary thresholds, and sponsorship rules." },
    { id: 2, title: "How to Secure Fully Funded Scholarships in Canada & Europe", category: "Scholarships", date: "August 5, 2026", author: "Senior Counsellor Desk", img: "https://images.unsplash.com/photo-1523240795612-9a054b0db644?auto=format&fit=crop&w=600&q=80", snippet: "Step-by-step roadmap for writing high-impact scholarship essays and securing 100% tuition waivers in Canada, Germany, and Ireland." },
    { id: 3, title: "Top 10 High-Demand STEM Courses in the US with 3-Year OPT", category: "Course Guides", date: "July 28, 2026", author: "Academic Research Team", img: "https://images.unsplash.com/photo-1501594907352-04cda38ebc29?auto=format&fit=crop&w=600&q=80", snippet: "Explore the most lucrative Master's programs in Data Science, Artificial Intelligence, and Robotics offering 36 months OPT in America." },
    { id: 4, title: "Germany Public Universities: Complete Free Education Guide", category: "Study Abroad Guides", date: "July 20, 2026", author: "Germany Desk", img: "https://images.unsplash.com/photo-1467269204594-9661b134dd2b?auto=format&fit=crop&w=600&q=80", snippet: "How to get admitted to English-taught Master's degrees in Germany with zero tuition fees and blocked account requirements." },
  ];

  const filtered = articles.filter(a => a.title.toLowerCase().includes(searchTerm.toLowerCase()) || a.category.toLowerCase().includes(searchTerm.toLowerCase()));

  return (
    <div className="consultancy-wrapper">
      <ConsultancyNavbar />

      {/* Banner */}
      <section className="py-5 consultancy-section-dark text-center">
        <div className="container">
          <span className="consultancy-badge-gold mb-2">Knowledge & Advice</span>
          <h1 className="display-5 font-weight-bold consultancy-gold-title mb-3">Study Abroad Insights & Guides</h1>
          <p className="consultancy-lead-text mx-auto mb-4" style={{ maxWidth: "650px" }}>
            Stay updated with the latest visa policies, university rankings, scholarship deadlines, and student life advice.
          </p>

          <div className="mt-3 mx-auto" style={{ maxWidth: "450px" }}>
            <input
              type="text"
              className="form-control consultancy-form-control text-center"
              placeholder="Search articles by title or keyword..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </div>
        </div>
      </section>

      {/* Grid */}
      <section className="py-5 container">
        <div className="row g-4">
          {filtered.map((a) => (
            <div key={a.id} className="col-lg-6">
              <div className="consultancy-glass-card overflow-hidden h-100 d-flex flex-column justify-content-between">
                <div>
                  <div style={{ height: "220px", overflow: "hidden" }}>
                    <img src={a.img} alt={a.title} className="w-100 h-100" style={{ objectFit: "cover" }} />
                  </div>
                  <div className="p-4">
                    <div className="d-flex justify-content-between align-items-center mb-2">
                      <span className="badge bg-warning text-dark font-weight-bold">{a.category}</span>
                      <small className="text-muted">{a.date}</small>
                    </div>

                    <h4 className="font-weight-bold consultancy-gold-title mb-2">{a.title}</h4>
                    <p className="text-muted small mb-3" style={{ lineHeight: "1.7" }}>{a.snippet}</p>
                  </div>
                </div>

                <div className="p-4 pt-0">
                  <Link to={`/consultancy/blog/${a.id}`} className="consultancy-btn-gold w-100 text-center">
                    Read Full Article <i className="fas fa-arrow-right ml-1"></i>
                  </Link>
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>

      <ConsultancyFooter />
    </div>
  );
};

export default BlogPage;
